import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, ChevronLeft, ChevronRight, Edit, Trash2, X } from 'react-feather'
import { useTranslation } from 'react-i18next'
import RestaurantCreateTable from './restaurantCreateTable'
import RestaurantCreateFloor from './restaurantCreateFloor'
import POSService from '../../../core/services/POSService'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import ImageWithBasePath from '../../../components/general/ImageCustom'

const RestaurantTable = ({
  floors,
  handleSelectTable,
  handleChangeTable,
  isUpdate,
  orderBySession,
  setFloor,
  posId,
  posContext,
  preparationOrders,
  handleViewTable,
  selectedTable,
  ordersOfTable,
  posConfigId,
  showConfirmationAlertCloseSession,
}) => {
  const MySwal = withReactContent(Swal)
  const [selectFloor, setSelectFloor] = useState(floors[0]?.id)
  const [tables, setTables] = useState([])
  const [updateTable, setUpdateTable] = useState({})
  const [updateFloor, setUpdateFloor] = useState(floors[0])
  const { t } = useTranslation()
  // Calculate total tables across all floors
  const totalTables = floors?.reduce((acc, floor) => acc + floor.table_ids.length, 0) || 0

  // pagination

  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 8 // Number of items to display per page
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = tables ? tables.slice(indexOfFirstItem, indexOfLastItem) : []
  const totalPages = tables ? Math.ceil(tables.length / itemsPerPage) : 0

  const showConfirmationAlertDeleteTable = (tableId) => {
    MySwal.fire({
      title: t('confirm_delete_table'),
      showCancelButton: true,
      confirmButtonColor: '#00ff00',
      confirmButtonText: t('confirm_yes'),
      cancelButtonColor: '#ff0000',
      cancelButtonText: t('confirm_no'),
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: t('notify_remove_table'),
          className: 'btn btn-success',
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
        handleDeleteTable(tableId)
      } else {
        MySwal.close()
      }
    })
  }

  const showConfirmationAlertDeleteFloor = (floorId) => {
    MySwal.fire({
      title: t('confirm_delete_floor'),
      showCancelButton: true,
      confirmButtonColor: '#00ff00',
      confirmButtonText: t('confirm_yes'),
      cancelButtonColor: '#ff0000',
      cancelButtonText: t('confirm_no'),
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: t('notify_remove_floor'),
          className: 'btn btn-success',
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
        handleDeleteFloor(floorId)
      } else {
        MySwal.close()
      }
    })
  }

  // Generate page numbers array
  const getPageNumbers = () => {
    const pageNumbers = []
    const maxVisiblePages = 5
    const halfVisible = Math.floor(maxVisiblePages / 2)

    let startPage = Math.max(1, currentPage - halfVisible)
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers
  }

  const handleSelectFloor = (floor) => {
    setSelectFloor(floor)
    setCurrentPage(1)
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const handleDeleteTable = async (tableId) => {
    await POSService.deleteTable(tableId).then((res) => {
      POSService.getListPOSById(posId).then((res) => {
        setFloor(res.records[0].floor_ids.sort((a, b) => a.id - b.id))
      })
    })
  }

  const handleDeleteFloor = async (floorId) => {
    await POSService.deleteFloor(floorId).then((res) => {
      POSService.getListPOSById(posId).then((res) => {
        setFloor(res.records[0].floor_ids.sort((a, b) => a.id - b.id))
      })
    })
  }

  useEffect(() => {
    if (posContext?.selected_table != null && posContext?.order_by_session != null) {
      handleViewTable(parseInt(posContext?.selected_table), posContext?.order_by_session)
    }
  }, [])

  useEffect(() => {
    if (currentItems.length == 0 && currentPage > 1) {
      setCurrentPage((prev) => prev - 1)
    }
  }, [currentItems])

  const preparationIdSet = new Set(preparationOrders?.map((order) => order.pos_order_id))

  const tableHasPreparationOrder = orderBySession?.records
    ?.filter((record) => preparationIdSet.has(record.id) && record.state === 'draft')
    .map((record) => record.table_id.id)

  const getPreparationOfTableByTableId = (tableId) => {
    let preparationOrders = ordersOfTable?.find((order) => order.table_id.id === tableId)?.preparationOrders
    return preparationOrders
  }

  useEffect(() => {
    setTables(floors.find((floor) => floor.id === selectFloor)?.table_ids)
  }, [floors, selectFloor])

  return (
    <div>
      <div className='page-wrapper-pos fade-in'>
        <div s className='content'>
          <div className='card'>
            <div className='card-body'>
              <div className='table-top table-top-two table-top-new'>
                <div className='container-fluid bg-[#F3F4F7]'>
                  <div className='d-flex align-items-center justify-content-between rounded-[10px] bg-white p-2'>
                    {!isUpdate && (
                      <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
                        <Link
                          to='/pos-session'
                          className='inline-flex shrink grow basis-0 items-center justify-center self-stretch'
                        >
                          <ImageWithBasePath src='assets/img/POS/arrow-left.svg' alt='' />
                        </Link>
                      </div>
                    )}
                    <div className={`paginations custom-pagination col-10`}>
                      <div className='paginations d-flex justify-content-center'>
                        <ul className='page-wrap grid w-full grid-cols-4 gap-1 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-12'>
                          {floors.map((floor) => {
                            return (
                              <li key={floor.id} className='d-flex align-items-center justify-content-center'>
                                <Link
                                  to='#'
                                  onClick={(e) => {
                                    e.preventDefault()
                                    handleSelectFloor(floor.id)
                                    setUpdateFloor(floor)
                                  }}
                                  className={`${selectFloor === floor.id ? 'active' : ''}`}
                                >
                                  {floor.name}
                                </Link>
                              </li>
                            )
                          })}
                          {!isUpdate && (
                            <li className='d-flex align-items-center justify-content-center'>
                              <Link
                                onClick={(e) => {
                                  e.preventDefault()
                                }}
                                data-bs-toggle='modal'
                                data-bs-target='#create-new-floor'
                              >
                                <svg
                                  width='17'
                                  height='16'
                                  viewBox='0 0 17 16'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <g id='icon/outlined/suggested/plus'>
                                    <g id='Vector'>
                                      <path
                                        d='M8.19824 2.375H9.13574C9.21908 2.375 9.26074 2.41667 9.26074 2.5V13.5C9.26074 13.5833 9.21908 13.625 9.13574 13.625H8.19824C8.11491 13.625 8.07324 13.5833 8.07324 13.5V2.5C8.07324 2.41667 8.11491 2.375 8.19824 2.375Z'
                                        fill='currentColor'
                                      />
                                      <path
                                        d='M3.41699 7.40625H13.917C14.0003 7.40625 14.042 7.44792 14.042 7.53125V8.46875C14.042 8.55208 14.0003 8.59375 13.917 8.59375H3.41699C3.33366 8.59375 3.29199 8.55208 3.29199 8.46875V7.53125C3.29199 7.44792 3.33366 7.40625 3.41699 7.40625Z'
                                        fill='currentColor'
                                      />
                                    </g>
                                  </g>
                                </svg>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                    {!isUpdate && (
                      <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
                        <div className='inline-flex shrink grow basis-0 items-center justify-center self-stretch'>
                          <div
                            className='dropdown pos-menu-action col-2'
                            onClick={(e) => {
                              e.preventDefault()
                            }}
                          >
                            <Link
                              className='dropdown-toggle'
                              data-bs-toggle='dropdown'
                              aria-expanded='false'
                              onClick={(e) => {
                                e.preventDefault()
                              }}
                            >
                              <ImageWithBasePath src='assets/img/POS/setting-2.svg' alt='' />
                            </Link>
                            <ul className='dropdown-menu'>
                              <li>
                                <Link
                                  to='#'
                                  className='dropdown-item'
                                  onClick={(e) => {
                                    e.preventDefault()
                                  }}
                                  data-bs-toggle='modal'
                                  data-bs-target='#update-floor'
                                >
                                  <span className='d-flex align-items-center'>
                                    <Edit className='feather-16 mr-2' />
                                    {t('edit_floor')}
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to='#'
                                  className='dropdown-item confirm-text mb-0'
                                  onClick={(e) => {
                                    e.preventDefault()
                                    showConfirmationAlertDeleteFloor(selectFloor)
                                  }}
                                >
                                  <span className='d-flex align-items-center me-1'>
                                    <Trash2 className='feather-16 mr-2' />
                                    {t('delete_floor')}
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to='#'
                                  className='dropdown-item'
                                  onClick={(e) => {
                                    showConfirmationAlertCloseSession()
                                    e.preventDefault()
                                  }}
                                >
                                  <span className='d-flex align-items-center me-1'>
                                    <X className='feather-16 mr-2' />
                                    {t('close_session')}
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to='/pos-session' className='dropdown-item'>
                                  <span className='d-flex align-items-center me-1'>
                                    <ArrowLeft className='feather-16 mr-2' />
                                    {t('back')}
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    style={{ minHeight: '70vh' }}
                    className='employee-grid-widget mt-4 rounded-[10px] bg-[#F3F4F7] p-2'
                  >
                    <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
                      {currentItems?.map((table) => (
                        <div className='inline-flex h-48 flex-col items-center justify-center gap-2 rounded-xl bg-white pb-6 shadow'>
                          <div
                            className={`inline-flex items-center justify-between rounded-tl-xl rounded-tr-xl px-3 py-2 ${!isUpdate ? 'self-stretch' : ''}`}
                          >
                            {!isUpdate && (
                              <div className='relative h-10 w-10 rounded-lg bg-[#f8f8f8]'>
                                <div className='absolute left-[8px] top-[8px] h-6 w-6'>
                                  <ImageWithBasePath src='assets/img/POS/order_preparation.svg' alt='' />
                                </div>

                                <div className='absolute left-[26px] top-[-2px] inline-flex h-4 flex-col items-center justify-center gap-2.5 rounded-[100px] bg-[#ed1c24] p-1'>
                                  <div className="font-['Montserrat'] text-xs font-normal leading-tight text-white">
                                    {getPreparationOfTableByTableId(table.id)?.length
                                      ? getPreparationOfTableByTableId(table.id).length
                                      : 0}
                                  </div>
                                </div>
                              </div>
                            )}

                            <div
                              className={`d-flex relative h-8 w-[156.50px] flex-col items-center justify-center rounded-bl-full rounded-br-full ${tableHasPreparationOrder?.includes(table.id) ? 'bg-[#fd525b]' : 'bg-[#28C76F]'}`}
                            >
                              <div className="font-['Inter'] text-base font-semibold leading-[18px] text-white">
                                {table.name}
                              </div>
                            </div>
                            {!isUpdate && (
                              <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
                                <div className='inline-flex shrink grow basis-0 items-center justify-center self-stretch'>
                                  <div
                                    className='dropdown pos-menu-action'
                                    onClick={(e) => {
                                      e.preventDefault()
                                    }}
                                  >
                                    <Link
                                      className='action-icon dropdown-toggle'
                                      data-bs-toggle='dropdown'
                                      aria-expanded='false'
                                      onClick={(e) => {
                                        e.preventDefault()
                                      }}
                                    >
                                      <ImageWithBasePath src='assets/img/POS/setting-2.svg' alt='' />
                                    </Link>
                                    <ul className='dropdown-menu'>
                                      <li>
                                        <Link
                                          to='#'
                                          className='dropdown-item'
                                          onClick={(e) => {
                                            e.preventDefault()
                                            setUpdateTable(table)
                                          }}
                                          data-bs-toggle='modal'
                                          data-bs-target='#update-table'
                                        >
                                          <span className='d-flex align-items-center me-1'>
                                            <Edit className='feather-16 mr-2' />
                                            {t('edit_table')}
                                          </span>
                                        </Link>
                                      </li>
                                      <li>
                                        <Link
                                          to='#'
                                          className='dropdown-item confirm-text mb-0'
                                          onClick={(e) => {
                                            e.preventDefault()
                                            showConfirmationAlertDeleteTable(table.id)
                                          }}
                                        >
                                          <span className='d-flex align-items-center me-1'>
                                            <Trash2 className='feather-16 mr-2' />
                                            {t('delete_table')}
                                          </span>
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className='inline-flex items-center justify-center pt-3'>
                            {/* <div className="font-['Inter'] text-sm font-semibold leading-tight text-[#0e121b]">
                                  Tổng hoá đơn:
                                </div>
                                <div className="font-['Inter'] text-base font-bold leading-normal text-[#fd525b]">
                                  100,000 VND
                                </div> */}

                            {tableHasPreparationOrder?.includes(table.id) ? (
                              <div className="font-['Inter'] text-sm font-semibold leading-tight text-[#0e121b]">
                                {t('has_order')}
                              </div>
                            ) : (
                              <div className="font-['Inter'] text-sm font-semibold leading-tight text-[#0e121b]">
                                {t('free_table')}
                              </div>
                            )}
                          </div>
                          <div className='flex h-20 flex-col items-center justify-end gap-2 self-stretch px-10'>
                            {tableHasPreparationOrder?.includes(table.id) ? (
                              <button
                                className={`inline-flex h-10 items-center justify-center gap-2.5 self-stretch rounded-lg border border-[#fd525b] px-4 py-2.5 text-[#FD525B] transition duration-200 ease-in-out hover:bg-[#fd525b] hover:text-white hover:shadow-lg`}
                                onClick={(e) => {
                                  e.preventDefault()
                                  isUpdate ? handleChangeTable(table.id) : handleSelectTable(table.id)
                                }}
                                disabled={table.id === selectedTable}
                              >
                                <svg
                                  width='17'
                                  height='16'
                                  viewBox='0 0 17 16'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                  className='icon'
                                >
                                  <g id='Frame'>
                                    <g id='Group'>
                                      <path
                                        id='Vector'
                                        fill-rule='evenodd'
                                        clip-rule='evenodd'
                                        d='M7.50049 1.33325H4.16716C2.69449 1.33325 1.50049 2.52725 1.50049 3.99992V11.9999C1.50049 13.4726 2.69449 14.6666 4.16716 14.6666H12.1672C13.6398 14.6666 14.8338 13.4726 14.8338 11.9999C14.8338 10.4859 14.8338 8.66659 14.8338 8.66659C14.8338 8.29859 14.5352 7.99992 14.1672 7.99992C13.7992 7.99992 13.5005 8.29859 13.5005 8.66659V11.9999C13.5005 12.7359 12.9032 13.3333 12.1672 13.3333C9.94715 13.3333 6.38649 13.3333 4.16716 13.3333C3.43049 13.3333 2.83382 12.7359 2.83382 11.9999C2.83382 9.77992 2.83382 6.21925 2.83382 3.99992C2.83382 3.26325 3.43049 2.66659 4.16716 2.66659H7.50049C7.86849 2.66659 8.16716 2.36792 8.16716 1.99992C8.16716 1.63192 7.86849 1.33325 7.50049 1.33325ZM12.5578 2.66659H10.1672C9.79916 2.66659 9.50049 2.36792 9.50049 1.99992C9.50049 1.63192 9.79916 1.33325 10.1672 1.33325H14.1672C14.5352 1.33325 14.8338 1.63192 14.8338 1.99992V5.99992C14.8338 6.36792 14.5352 6.66659 14.1672 6.66659C13.7992 6.66659 13.5005 6.36792 13.5005 5.99992V3.60925L8.63849 8.47125C8.37849 8.73125 7.95582 8.73125 7.69582 8.47125C7.43515 8.21125 7.43515 7.78859 7.69582 7.52858L12.5578 2.66659Z'
                                        fill='currentColor'
                                      />
                                    </g>
                                  </g>
                                </svg>
                                <div className="font-['Inter'] text-sm font-medium leading-tight">
                                  {isUpdate ? t('change_table') : t('open')}
                                </div>
                              </button>
                            ) : (
                              <button
                                className={`inline-flex h-10 items-center justify-center gap-2.5 self-stretch rounded-lg border border-[#28C76F] px-4 py-2.5 text-[#28C76F] transition duration-200 ease-in-out hover:bg-[#28C76F] hover:text-white hover:shadow-lg`}
                                onClick={(e) => {
                                  e.preventDefault()
                                  isUpdate ? handleChangeTable(table.id) : handleSelectTable(table.id)
                                }}
                                style={{
                                  backgroundColor: table.id === selectedTable ? '#8496a6' : '',
                                  color: table.id === selectedTable ? 'white' : '',
                                }}
                                disabled={table.id === selectedTable}
                              >
                                <svg
                                  width='17'
                                  height='16'
                                  viewBox='0 0 17 16'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <g id='icon/outlined/suggested/plus'>
                                    <g id='Vector'>
                                      <path
                                        d='M8.19824 2.375H9.13574C9.21908 2.375 9.26074 2.41667 9.26074 2.5V13.5C9.26074 13.5833 9.21908 13.625 9.13574 13.625H8.19824C8.11491 13.625 8.07324 13.5833 8.07324 13.5V2.5C8.07324 2.41667 8.11491 2.375 8.19824 2.375Z'
                                        fill='currentColor'
                                      />
                                      <path
                                        d='M3.41699 7.40625H13.917C14.0003 7.40625 14.042 7.44792 14.042 7.53125V8.46875C14.042 8.55208 14.0003 8.59375 13.917 8.59375H3.41699C3.33366 8.59375 3.29199 8.55208 3.29199 8.46875V7.53125C3.29199 7.44792 3.33366 7.40625 3.41699 7.40625Z'
                                        fill='currentColor'
                                      />
                                    </g>
                                  </g>
                                </svg>

                                <div className="font-['Inter'] text-sm font-medium leading-tight">
                                  {isUpdate ? t('change_table') : t('create_order')}
                                </div>
                              </button>
                            )}
                          </div>
                        </div>
                      ))}

                      {currentItems.length < 9 && !isUpdate && (
                        <div className='inline-flex h-48 flex-col items-center justify-center gap-2 rounded-xl bg-white pb-6 shadow'>
                          <div className='inline-flex items-center justify-center self-stretch rounded-tl-xl rounded-tr-xl px-3 py-2'>
                            {/* <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
                              <ImageWithBasePath src='assets/img/POS/order_preparation.svg' alt='' />
                            </div> */}
                            <div className='d-flex relative h-8 w-[156.50px] flex-col items-center justify-center rounded-bl-full rounded-br-full bg-[#525866]'>
                              <div className="font-['Inter'] text-base font-semibold leading-[18px] text-white">
                                {t('table')}
                              </div>
                            </div>
                            {/* <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
                              <ImageWithBasePath src='assets/img/POS/setting-2.svg' alt='' />
                            </div> */}
                          </div>
                          <div
                            className='inline-flex items-center justify-center gap-1'
                            data-bs-toggle='modal'
                            data-bs-target='#create-new-table'
                          >
                            <ImageWithBasePath src='assets/img/POS/add.svg' alt='' />
                          </div>
                          <div
                            className='flex h-20 flex-col items-center justify-end gap-2 self-stretch px-10'
                            data-bs-toggle='modal'
                            data-bs-target='#create-new-table'
                          >
                            <div className='inline-flex h-10 items-center justify-center gap-2.5 self-stretch rounded-lg border border-[#28c76f] px-4 py-2.5 transition duration-200 ease-in-out hover:bg-[#525866] hover:text-white hover:shadow-lg'>
                              <svg
                                width='17'
                                height='16'
                                viewBox='0 0 17 16'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <g id='icon/outlined/suggested/plus'>
                                  <g id='Vector'>
                                    <path
                                      d='M8.19824 2.375H9.13574C9.21908 2.375 9.26074 2.41667 9.26074 2.5V13.5C9.26074 13.5833 9.21908 13.625 9.13574 13.625H8.19824C8.11491 13.625 8.07324 13.5833 8.07324 13.5V2.5C8.07324 2.41667 8.11491 2.375 8.19824 2.375Z'
                                      fill='currentColor'
                                    />
                                    <path
                                      d='M3.41699 7.40625H13.917C14.0003 7.40625 14.042 7.44792 14.042 7.53125V8.46875C14.042 8.55208 14.0003 8.59375 13.917 8.59375H3.41699C3.33366 8.59375 3.29199 8.55208 3.29199 8.46875V7.53125C3.29199 7.44792 3.33366 7.40625 3.41699 7.40625Z'
                                      fill='currentColor'
                                    />
                                  </g>
                                </g>
                              </svg>
                              <div className="font-['Inter'] text-sm font-medium leading-tight">
                                {t('create_table')}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='mb-3 mt-4 flex items-center justify-center gap-2'>
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className='rounded p-2 hover:bg-gray-100 disabled:opacity-50'
                    >
                      <ChevronLeft className='h-5 w-5' />
                    </button>

                    {getPageNumbers().map((number) => (
                      <button
                        key={number}
                        onClick={() => handlePageChange(number)}
                        className={`rounded px-3 py-1 ${
                          currentPage === number ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                        }`}
                      >
                        {number}
                      </button>
                    ))}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className='rounded p-2 hover:bg-gray-100 disabled:opacity-50'
                    >
                      <ChevronRight className='h-5 w-5' />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <RestaurantCreateTable floorId={selectFloor} setFloor={setFloor} posId={posId} updateTable={updateTable} />
          <RestaurantCreateFloor
            posConfigId={posConfigId}
            setFloor={setFloor}
            posId={posId}
            updateFloor={updateFloor}
          />
        </div>
      </div>
    </div>
  )
}

export default RestaurantTable
